export default __webpack_public_path__ + "static/media/upload_cloud_filled.4a284fd3.svg";